import { Link } from 'react-router-dom';
import { Instagram, ArrowUpRight } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_07dd2ee2-42aa-4d8a-a966-79b38cca8e94/artifacts/skr2sta7_Logo.png";

export default function Footer() {
    return (
        <footer data-testid="footer" className="bg-brand-bg border-t border-brand-border">
            <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16">
                <div className="grid md:grid-cols-3 gap-12">
                    {/* Brand */}
                    <div>
                        <img 
                            src={LOGO_URL} 
                            alt="StillFaded" 
                            className="h-16 w-auto mb-6"
                        />
                        <p className="font-space text-slate-400 text-sm leading-relaxed">
                            Hip-hop. Neo-soul. Indie pop.<br />
                            The sound of being faded.
                        </p>
                    </div>

                    {/* Links */}
                    <div>
                        <h4 className="font-syne font-bold text-white uppercase tracking-widest mb-6">Navigate</h4>
                        <nav className="space-y-4">
                            {[
                                { name: 'Home', path: '/' },
                                { name: 'Music', path: '/music' },
                                { name: 'Merch', path: '/merch' },
                                { name: 'Tour', path: '/tour' },
                            ].map((link) => (
                                <Link
                                    key={link.path}
                                    to={link.path}
                                    data-testid={`footer-link-${link.name.toLowerCase()}`}
                                    className="block font-space text-slate-400 hover:text-white transition-colors duration-300"
                                >
                                    {link.name}
                                </Link>
                            ))}
                        </nav>
                    </div>

                    {/* Social */}
                    <div>
                        <h4 className="font-syne font-bold text-white uppercase tracking-widest mb-6">Connect</h4>
                        <div className="space-y-4">
                            <a
                                href="https://instagram.com/faded.keenan"
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="social-instagram-artist"
                                className="flex items-center gap-3 font-space text-slate-400 hover:text-white transition-colors duration-300 group"
                            >
                                <Instagram className="w-5 h-5" />
                                <span>@faded.keenan</span>
                                <ArrowUpRight className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity" />
                            </a>
                            <a
                                href="https://instagram.com/stillfaded.tx"
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="social-instagram-brand"
                                className="flex items-center gap-3 font-space text-slate-400 hover:text-white transition-colors duration-300 group"
                            >
                                <Instagram className="w-5 h-5" />
                                <span>@stillfaded.tx</span>
                                <ArrowUpRight className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity" />
                            </a>
                        </div>
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-brand-border flex flex-col md:flex-row justify-between items-center gap-4">
                    <p className="font-mono text-xs text-slate-600 uppercase tracking-widest">
                        © 2026 STILLFADEDWORLD.COM. ALL RIGHTS RESERVED.
                    </p>
                </div>
            </div>
        </footer>
    );
}
